.sorting-slideout .sorting-option {
  display: grid;
  grid-template-columns: 24px 1fr;
  align-items: center;
  width: 100vw;
  padding: 14px 20px;
  cursor: pointer;
}
.sorting-slideout .sorting-option .icon-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}
.sorting-slideout .sorting-option .label-cell {
  padding-left: 8px;
}
.sorting-slideout .scrollable-content {
  margin-left: -20px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiQzpcXGlvXFxldGV4LWh1YnN0ZXJcXHNyY1xcRnJvbnRlbmRcXGhlYWRsZXNzXFxtb2R1bGVzXFxldGV4XFxzcmNcXGNvbXBvbmVudHNcXHNsaWRlb3V0XFxzb3J0aW5nLW1vYmlsZSIsInNvdXJjZXMiOlsic29ydGluZ01vYmlsZVBhbmVsLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0U7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTs7QUFJSjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLnNvcnRpbmctc2xpZGVvdXQge1xyXG4gIC5zb3J0aW5nLW9wdGlvbiB7XHJcbiAgICBkaXNwbGF5OiBncmlkO1xyXG4gICAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiAyNHB4IDFmcjtcclxuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XHJcbiAgICB3aWR0aDogMTAwdnc7XHJcbiAgICBwYWRkaW5nOiAxNHB4IDIwcHg7XHJcbiAgICBjdXJzb3I6IHBvaW50ZXI7XHJcblxyXG4gICAgLmljb24tY2VsbCB7XHJcbiAgICAgIGRpc3BsYXk6IGZsZXg7XHJcbiAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XHJcbiAgICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xyXG4gICAgfVxyXG5cclxuICAgIC5sYWJlbC1jZWxsIHtcclxuICAgICAgcGFkZGluZy1sZWZ0OiA4cHg7XHJcbiAgICB9XHJcbiAgfVxyXG5cclxuICAuc2Nyb2xsYWJsZS1jb250ZW50IHtcclxuICAgIG1hcmdpbi1sZWZ0OiAtMjBweDtcclxuICB9XHJcbn1cclxuIl19 */